import axios from "axios";
import { environments } from "../environments";
import { getTokens } from "../services/data";

export const apiCadastro = axios.create({
  baseURL: environments.urlApiCadastro,
});

apiCadastro.interceptors.request.use(
  (config) => {
    config.headers["Authorization"] = `Bearer ${getTokens()["x-auth-token"]}`;
    return config;
  },
  (error) => {
    return Promise.reject(error);
  },
);
